module.exports = __webpack_public_path__ + "img/Time_for_a_Post-Trade_Upgrade.55916768.jpg";